import React from 'react';
import styled from 'styled-components/macro';
import { Search, Dropdown } from 'lib/components';

import { VerificationStatusOptions } from 'lib/const/VerificationsStatusOptions';
import { CustomersDropdown } from '../../components/CustomersDropdown';
import { theme } from 'lib/style';

const Customise = styled.div`
  float: right;
  color: #001b53;
  ${theme.mediaQueryMinWidth.sm} {
    width: 205px;
  }
  text-align: end;
  text-decoration: underline;
  cursor: pointer;
`;

const FiltersContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  width: 100%;
  justify-content: space-between;
`;

type FilterProps = {
  marginRight?: number;
  width?: number;
};
export const Filter = styled.div<FilterProps>`
  min-width: 224px;
  width: ${props => `${props.width}px` || 'auto'};
  margin-right: ${props => `${props.marginRight}px` || '0px'};
`;

type Props = {
  prevSearch?: string;
  statusFilter?: number;
  customerFilter?: number;
  showCustomerFilter: boolean;
  onSelectStatus(statusValue: number): void;
  onSelectCustomer(customerId: number): void;
  onSearch(search: string): void;
  setIsCustomizeTableModel: (value: boolean) => void;
  setCustomersLength?: (value: number) => void;
};

export const SearchAndFilter = ({
  prevSearch,
  statusFilter,
  customerFilter,
  showCustomerFilter,
  onSelectStatus,
  onSelectCustomer,
  onSearch,
  setIsCustomizeTableModel,
  setCustomersLength,
}: Props) => {
  return (
    <FiltersContainer>
      <Filter width={536} marginRight={12}>
        <Search
          placeholder='Search by name, customer or email...'
          onSearch={onSearch}
          prevSearch={prevSearch}
        />
      </Filter>

      <Filter width={224} marginRight={12}>
        <Dropdown
          height={40}
          creatable={false}
          className='dropdown'
          placeholder={'Filter by Statuses'}
          zIndexProp={1}
          value={VerificationStatusOptions.find(
            option => option.value === statusFilter
          )}
          onChange={value => onSelectStatus(value.value)}
          options={VerificationStatusOptions}
        />
      </Filter>

      <Filter width={224}>
        {showCustomerFilter && (
          <CustomersDropdown
            showAllCustomersOption={true}
            customerFilter={customerFilter}
            onSelectCustomer={onSelectCustomer}
            zIndexProp={1}
            setCustomersLength={setCustomersLength}
          />
        )}
      </Filter>
      <Customise onClick={() => setIsCustomizeTableModel(true)}>
        Customize table
      </Customise>
    </FiltersContainer>
  );
};
